import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=2268a5d5&scoped=true"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=2268a5d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268a5d5",
  null
  
)

export default component.exports